/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetGipReportEvidenceExportUrl0QueryResponse, GetGipReportEvidenceExportUrl0PathParams, GetGipReportEvidenceExportUrl0404 } from "../models/GetGipReportEvidenceExportUrl0";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getGipReportEvidenceExportUrl0 } from "../axios/getGipReportEvidenceExportUrl0";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getGipReportEvidenceExportUrl0QueryKey = (id: GetGipReportEvidenceExportUrl0PathParams["id"]) => ["audit-reports-api", { url: '/reports/gip/report/:id/evidence-export-url', params: {id:id} }] as const

export type GetGipReportEvidenceExportUrl0QueryKey = ReturnType<typeof getGipReportEvidenceExportUrl0QueryKey>

export function getGipReportEvidenceExportUrl0QueryOptions(id: GetGipReportEvidenceExportUrl0PathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getGipReportEvidenceExportUrl0QueryKey(id)
        return queryOptions<GetGipReportEvidenceExportUrl0QueryResponse, ResponseErrorConfig<GetGipReportEvidenceExportUrl0404>, GetGipReportEvidenceExportUrl0QueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getGipReportEvidenceExportUrl0(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get export URL for existing report
 * {@link /reports/gip/report/:id/evidence-export-url}
 */
export function useGetGipReportEvidenceExportUrl0<TData = GetGipReportEvidenceExportUrl0QueryResponse, TQueryData = GetGipReportEvidenceExportUrl0QueryResponse, TQueryKey extends QueryKey = GetGipReportEvidenceExportUrl0QueryKey>(id: GetGipReportEvidenceExportUrl0PathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetGipReportEvidenceExportUrl0QueryResponse, ResponseErrorConfig<GetGipReportEvidenceExportUrl0404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getGipReportEvidenceExportUrl0QueryKey(id)
         

         const query = useQuery({
          ...getGipReportEvidenceExportUrl0QueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetGipReportEvidenceExportUrl0404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}